export const notesData = [
    {
        id: 1,
        title: "Book a Ticket for Movie",
        date: "11 March 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "tasks",
    },
    {
        id: 2,
        title: "Go for lunch ",
        date: "01 April 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "important",
    },
    {
        id: 3,
        title: "Meeting with Mr.Jojo ",
        date: "19 October 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "works",
    },
    {
        id: 4,
        title: "Give Review for design ",
        date: "02 January 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "business",
    },
    {
        id: 5,
        title: "Nightout with friends",
        date: "01 August 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "archive",
    },
    {
        id: 6,
        title: "Launch new template",
        date: "21 January 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "personal",
    },
    {
        id: 7,
        title: "Change a Design",
        date: "25 December 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "works",
    },
    {
        id: 8,
        title: "Give salary to employee",
        date: "15 Fabruary 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "priority",
    },
    {
        id: 9,
        title: "Nightout with friends",
        date: "18 December 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "important",
    },
    {
        id: 10,
        title: "Go for lunch",
        date: "01 April 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "archive",
    },
    {
        id: 11,
        title: "Meeting with Mr.Jojo ",
        date: "19 October 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "works",
    },
    {
        id: 12,
        title: "Go for lunch",
        date: "01 April 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "tasks",
    },
    {
        id: 13,
        title: "Change a Design",
        date: "25 December 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "social",
    },
    {
        id: 14,
        title: "Give salary to employee",
        date: "15 Fabruary 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "social",
    },
    {
        id: 15,
        title: "Give salary to employee",
        date: "15 Fabruary 2023",
        content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis vitae iure, quo harum excepturi laudantium eum earum accusantium labore libero maiores illo soluta.",
        category: "tasks",
    },
]